import { render, staticRenderFns } from "./thanks.vue?vue&type=template&id=42b8a72e&scoped=true&"
import script from "./thanks.vue?vue&type=script&lang=ts&"
export * from "./thanks.vue?vue&type=script&lang=ts&"
import style0 from "./thanks.vue?vue&type=style&index=0&id=42b8a72e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b8a72e",
  null
  
)

component.options.__file = "thanks.vue"
export default component.exports